import {
  button_children,
  bigScreen_button_children,
  app_button_children,
  wxLink_button_children,
  drawer_button_children,
  app_drawer_button_children,
  popover_button_children,
  app_popover_button_children,
  collect_button_children,
  like_button_children,
  ip_button_children,
  return_button_children,
  bigScreen_return_button_children,
} from "./menus/index"
import { getOptDes } from "./menus/optDes"

const cxButton = {
  name: "cxButton",
  desc: "按钮",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "按钮",
        children: app_button_children,
        group: "baseElement",
        sort: 10,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "抽屉",
        children: app_drawer_button_children,
        group: "element",
        enable(params) {
          let phoneFullScreenFlag = true
          if ("phoneFullScreenFlag" in params && params.phoneFullScreenFlag === false) {
            phoneFullScreenFlag = false
          }
          return phoneFullScreenFlag
        },
        sort: 140,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "弹出框",
        children: app_popover_button_children,
        group: "element",
        enable(params) {
          let phoneFullScreenFlag = true
          if ("phoneFullScreenFlag" in params && params.phoneFullScreenFlag === false) {
            phoneFullScreenFlag = false
          }
          return phoneFullScreenFlag
        },
        sort: 141,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "小程序链接",
        children: wxLink_button_children,
        group: "highLevel",
        sort: 7,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "收藏按钮",
        children: collect_button_children,
        group: "highLevel",
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return !detailPageBusinessFlag
        },
        sort: 140,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "点赞按钮",
        children: like_button_children,
        group: "highLevel",
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 140,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "IP",
        children: ip_button_children,
        type:"cxIP",
        group: "element",
        sort: 141,
        cover: require("assets/images/leftMenu/IP/style1.png")
      }
    ],
    bigScreen: [
      {
        name: "按钮",
        children: bigScreen_button_children,
        group: "baseElement"
      },
      {
        name: "返回",
        children: bigScreen_return_button_children,
        group: "component",
        sort: 142,
        cover: require("assets/images/leftMenu/component/cx_return.png")
      },
    ],
    portal: [
      {
        name: "按钮",
        children: button_children,
        group: "baseElement",
        sort: 10,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "抽屉",
        children: drawer_button_children,
        group: "element",
        sort: 140,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "弹出框",
        children: popover_button_children,
        group: "element",
        sort: 141,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "收藏按钮",
        children: collect_button_children,
        group: "element",
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 143,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "点赞按钮",
        children: like_button_children,
        group: "element",
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 144,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
      {
        name: "IP",
        children: ip_button_children,
        group: "element",
        type:"cxIP",
        sort: 141,
        cover: require("assets/images/leftMenu/IP/style1.png")
      },
      {
        name: "返回",
        children: return_button_children,
        group: "element",
        sort: 142,
        cover: require("assets/images/leftMenu/button/style1.png")
      },
    ]
  },
  toolbars: [
    {
      name: "cxButton",
      label: "按钮",
      comp: {
        buttonComponentData: () => import("./toolbars/button-options-data.vue"),
        buttonComponentSetting: () => import("./toolbars/button-options-setting.vue"),
        buttonComponentStyle: () => import("./toolbars/button-options-style.vue"),
        buttonComponentConfig: () => import("./toolbars/button-options-config.vue")
      }
    }
  ]
}

export default cxButton

